import { sendPasswordResetEmail } from 'firebase/auth';
import { stimuliBackendBaseUrl } from '../stimuli/stimulusUploads';

function backendBaseUrl(baseUrl) {
  return (baseUrl || stimuliBackendBaseUrl()).replace(/\/+$/, '');
}

function responseDetail(response, fallback) {
  const detail = response && typeof response === 'object' ? response.detail : null;
  return typeof detail === 'string' && detail ? detail : fallback;
}

// Creates the Firebase login and its linked users profile in one backend call.
// The login has no password or custom claims; the person sets a password from
// the activation email.
export async function createUser({
  baseUrl,
  token,
  organizationId,
  name,
  email,
  role,
  active,
  fetchImpl = globalThis.fetch,
}) {
  const response = await fetchImpl(`${backendBaseUrl(baseUrl)}/admin/users`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ name, email, role, active, orgid: organizationId }),
  });
  let body = {};
  try {
    body = await response.json();
  } catch (_error) {
    body = {};
  }
  if (!response.ok) {
    throw new Error(responseDetail(body, `User creation failed (HTTP ${response.status}).`));
  }
  return body;
}

// The activation email is Firebase's password reset email. Its link expires,
// so send it close to when the person will actually set up their device.
export function sendActivationEmail({ auth, email, sendImpl = sendPasswordResetEmail }) {
  return sendImpl(auth, email);
}
